export default __webpack_public_path__ + "static/media/units.89ba852a.svg";